import { render, staticRenderFns } from "./SimpleCheckbox.vue?vue&type=template&id=d71ed41c&scoped=true"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=js"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71ed41c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
